module.exports = __webpack_public_path__ + "downloads/Datasource.d055dde9.xlsx";